import { motion } from "framer-motion";
import { useFactors } from "../state/FactorsContext";
import { describeResult } from "../lib/describe";
import HeroNumber from "./HeroNumber";
import GlobalControls from "./GlobalControls";

/**
 * The end of the descent. After every filter has had its say, this is where the
 * number lands — and where the analogy makes it land emotionally.
 */
export default function Finale() {
  const { data, result } = useFactors();
  const { meta } = data;
  const { plain, analogy } = describeResult(result.total);

  return (
    <section className="mx-auto max-w-2xl py-24 text-center">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
      >
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-cyan/80">
          The Silence
        </p>
        <p className="mx-auto mt-3 mb-10 max-w-md text-sm uppercase tracking-[0.2em] text-white/60">
          {meta.resultLabel}
        </p>

        <div className="relative">
          <div
            aria-hidden
            className="absolute inset-0 -z-10 blur-3xl"
            style={{
              background:
                "radial-gradient(closest-side, rgba(255,206,110,0.18), transparent 70%)",
            }}
          />
          <HeroNumber value={result.total} />
        </div>

        <p className="mx-auto mt-8 max-w-md font-mono text-sm text-cyan">
          {plain}
        </p>
        <p className="mx-auto mt-4 max-w-lg font-display text-xl font-light italic leading-relaxed text-white/85 sm:text-2xl">
          “{analogy}”
        </p>

        {meta.resultUnit && (
          <p className="mx-auto mt-4 max-w-md text-xs text-white/45">
            {meta.resultUnit}
          </p>
        )}
      </motion.div>

      {/* Desktop has the persistent side-panel controls; show here on mobile. */}
      <div className="mt-16 lg:hidden">
        <GlobalControls />
      </div>
    </section>
  );
}
